import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
interface WithLoadingProps {
  loading: boolean;
  loading_element: React.ReactNode;
  long_loading_element?: React.ReactNode;
  children: React.ReactNode;
}
const WithLoader: React.FC<WithLoadingProps> = t0 => {
  const $ = _c(7);
  const {
    loading,
    loading_element,
    long_loading_element,
    children
  } = t0;
  const [show_long_loader, setShowLongLoader] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handler = setTimeout(() => {
        setShowLongLoader(true);
      }, 10000);
      return () => {
        clearTimeout(handler);
      };
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== loading) {
    t2 = [loading];
    $[1] = loading;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (loading) {
    const t3 = long_loading_element && show_long_loader ? long_loading_element : loading_element;
    let t4;
    if ($[3] !== t3) {
      t4 = <>{t3}</>;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  if (show_long_loader) {
    setShowLongLoader(false);
  }
  let t3;
  if ($[5] !== children) {
    t3 = <>{children}</>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default WithLoader;